import { authenticatedAPI } from '../AuthenticatedAPI';
import {
  appointmentResDto,
  nachversandBookingLinkResDto,
  nachversandAppointmentResDto,
} from '@web/common';
import type { NachversandAppointmentType } from '@web/common';

export const getMyLatestAppointment = async () => {
  return authenticatedAPI.get(`/api/appointment/me/latest`, appointmentResDto);
};

export const getNachversandBookingLink = async (
  type: NachversandAppointmentType,
) => {
  return authenticatedAPI.get(
    `/api/appointment/nachversand-booking-link?type=${type}`,
    nachversandBookingLinkResDto,
  );
};

export const getNachversandAppointment = async (
  type: NachversandAppointmentType,
) => {
  return authenticatedAPI.get(
    `/api/appointment/nachversand?type=${type}`,
    nachversandAppointmentResDto,
  );
};
